import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { dict } from "../lib/i18n";

const I18nContext = createContext(null);

const getInitialLang = () => {
  if (typeof window === "undefined") return "fr";
  const saved = window.localStorage.getItem("vs_lang");
  if (saved === "fr" || saved === "en") return saved;
  const nav = (window.navigator.language || "fr").slice(0, 2);
  return nav === "en" ? "en" : "fr";
};

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((l) => {
    setLangState(l);
    try {
      window.localStorage.setItem("vs_lang", l);
    } catch {
      /* ignore */
    }
  }, []);

  const toggle = useCallback(() => setLang(lang === "fr" ? "en" : "fr"), [lang, setLang]);

  const t = useCallback(
    (key) => (dict[lang] && dict[lang][key]) || (dict.fr && dict.fr[key]) || key,
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, setLang, toggle, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
